import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { IntercomProvider } from 'react-use-intercom';
import {
  checkCorporateUser,
  getSuppilerPermission,
} from '../../utils/commonFunctions';
import { userType } from '../../constants/commondata';

const PROVIDER_CHAT_TYPE = {
  intercom: 'intercom',
};

const IntercomChat = ({ auth, commonData }) => {
  const supportSocial = auth?.selectedFleet?.supportSocial || {};

  const getAppId = (keySetting) => {
    const fullKey = keySetting || '';
    return fullKey.split('/')[0];
  };

  const checkEnableWithCorporateUser = () => {
    if (
      supportSocial.providerCorp !== PROVIDER_CHAT_TYPE.intercom ||
      !getAppId(supportSocial.intercomCorp) ||
      !auth?.user?.userIdHashIntercom
    )
      return null;
    return {
      name: auth?.user?.roles?.fullName || '',
      email: auth?.user?.email || '',
      phone: auth?.user?.phone || '',
      userId: auth?.user?._id,
      userHash: auth?.user?.userIdHashIntercom,
      company: {
        companyId: auth?.user?.corporateId,
        name: auth?.user?.corporateAccount?.companyInfo?.name || '',
        operatorUserName: auth?.user?.corporateAccount?.fullName || '',
      },
      customAttributes: {
        user_type:
          auth?.user?.userType === userType.CorporateUser
            ? 'Corporate User'
            : 'Corporate Admin',
        user_name: auth?.user?.userName || '',
        fleetId: auth?.selectedFleet?.fleetId || '',
      },
      appId: getAppId(supportSocial.intercomCorp),
    };
  };

  const checkEnableWithSupplierUser = () => {
    if (
      supportSocial.providerSup !== PROVIDER_CHAT_TYPE.intercom ||
      !getAppId(supportSocial.intercomSup) ||
      !commonData.companies?.[0]?._id ||
      !auth?.user?.userIdHashIntercom
    )
      return false;
    return {
      name: auth?.user?.roles?.fullName || '',
      email: auth?.user?.email,
      userId: auth?.user?._id,
      phone: auth?.user?.phone || '',
      userHash: auth?.user?.userIdHashIntercom,
      company: {
        companyId: commonData.companies[0]._id,
        name: commonData.companies[0]?.name || '',
      },
      customAttributes: {
        user_type: 'Supplier',
        user_name: auth?.user?.userName || '',
        fleetId: auth?.selectedFleet?.fleetId || '',
      },
      appId: getAppId(supportSocial.intercomSup),
    };
  };

  const intercomData = useMemo(() => {
    if (checkCorporateUser(auth?.user)) return checkEnableWithCorporateUser();
    if (getSuppilerPermission(auth)) return checkEnableWithSupplierUser();
    return null;
  }, []);

  if (!intercomData) return null;

  return (
    <IntercomProvider
      appId={intercomData.appId}
      shouldInitialize={true}
      autoBoot={true}
      autoBootProps={{
        ...intercomData,
        hide_default_launcher: false,
      }}
    />
  );
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    selectedFleet: state.selectedFleet,
    commonData: state.commonData,
  };
}

export default connect(mapStateToProps)(IntercomChat);
